import { render, staticRenderFns } from "./BliMedlem.vue?vue&type=template&id=2f0611d6&scoped=true&"
import script from "./BliMedlem.vue?vue&type=script&lang=js&"
export * from "./BliMedlem.vue?vue&type=script&lang=js&"
import style0 from "./BliMedlem.vue?vue&type=style&index=0&id=2f0611d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0611d6",
  null
  
)

export default component.exports